var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',{attrs:{"id":"swell-customer-identification","data-authenticated":_vm.authenticated,"data-email":_vm.$store.state.customer.email,"data-id":_vm.$store.state.customer.id,"data-tags":_vm.tags}})])}
var staticRenderFns = []

export { render, staticRenderFns }